import Chat from './pages/Chat';
import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';

export default [
  {
    path: ':sessionId',
    element: Chat,
  },
] as Array<EnhancedRouteProps>;
